<template>
    <div>

        <vue-headful title="Reseller Accounts :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-sitemap"></i> Reseller Accounts</li>
                <li class="ml-3">
                    <router-link :to="`/resellers/accounts/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create Account</router-link>
                </li>
            </ol>
        </h4>
        <hr />
        <div class="card">
            <div class="card-body">
                <v-server-table ref="obsTable" url="/resellers/accounts/list" :columns="columns" :options="options">

                    <router-link slot="SmartBizClientId" slot-scope="props" :to="`/resellers/accounts/view/${props.row.SmartBizClientId}`" title="View Account" class="btn btn-sm btn-light">
                        View - {{ props.row.SmartBizClientId }}
                    </router-link>

                    <router-link slot="ClientName" slot-scope="props" :to="`/resellers/accounts/view/${props.row.SmartBizClientId}`" title="View Account">
                        {{ props.row.ClientName }}
                    </router-link>

                    <template slot="created_at" slot-scope="props">
                        {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm a") }}
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                userFilterId: {},
                columns: [
                    'SmartBizClientId',
                    'ClientName',
                    'created_at'
                ],
                options: {
                    headings: {
                        SmartBizClientId: 'ID',
                        ClientName: 'Name',
                        created_at: 'Created',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'ClientName',
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'SmartBizClientId',
                },
            }
        },

        methods: {

        },
    }
</script>
